import React from 'react'

const debug = false
// const debug = "FieldIcon_ValueEmpty"

export default function FieldIcon_ValueEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    const classes = Classes("ui5-txt-no-accent-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className, {
        "is-disabled": props.disabled
    })

    return (
        <>
            <div className  = {classes}
                 onClick    = {props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {props.field.placeholder}
            </div>
            {props.children}
        </>
    )
}
